<template>
    <section class="footer">
        <span> © TEST, 1022–2022</span>
    </section>
</template>

<style lang="scss">
.footer {
    height: 200px;
    background: #141414;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding: 18px;
    & span {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #FFFFFF;
    }
}

@media screen and (max-width: 768px) {
    .footer{
        height: 100px;
    }
}
</style>